<template>
  <div class="graph-filters">
    <v-row>
      <v-col class="d-flex" sm="1">
        <!-- <v-overflow-btn>がいいかも
          <v-text-field
          label="世代"
          single-line
          v-model="selectedGeneration"
          color="purple darken-2"
        ></v-text-field> -->
        <v-select
					:items="generationList"
					label="世代"
					solo
					hide-details
					v-model="selectedGeneration"
        ></v-select>
      </v-col>
      <v-col class="d-flex" sm="1">
        <!-- <v-text-field
          label="書類"
          single-line
          v-model="selectedDocument"
          color="purple darken-2"
        ></v-text-field> -->
        <v-select
					:items="documentList"
					label="書類"
					solo
					hide-details
					v-model="selectedDocument"
        ></v-select>
      </v-col>
      <v-col class="d-flex" sm="1">
        <!-- <v-text-field
          label="社員"
          single-line
          v-model="selectedEmployee"
          color="purple darken-2"
        ></v-text-field> -->
        <v-select
					:items="employeeList"
					label="社員"
					solo
					hide-details
					v-model="selectedEmployee"
        ></v-select>
      </v-col>
      <v-col class="d-flex" sm="1">
        <!-- <v-text-field
          label="部門"
          single-line
          v-model="selectedDepartment"
          color="purple darken-2"
        ></v-text-field> -->
        <v-select
					:items="departmentList"
					label="部門"
					solo
					hide-details
					v-model="selectedDepartment"
        ></v-select>
      </v-col>
      <v-col class="d-flex" sm="1">
        <v-menu
          ref="startDateMenu"
          v-model="startDateMenu"
          :close-on-content-click="false"
          :return-value.sync="startDate"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDate"
              label="Start Date"
              readonly
              v-on="on"
              append-icon="mdi-calendar-range"
              color="purple darken-2"
              ></v-text-field
            >
          </template>
          <v-date-picker v-model="startDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="startDateMenu = false"
              >Cancel</v-btn
            >
            <v-btn
              text
              color="primary"
              @click="$refs.startDateMenu.save(startDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="d-flex" sm="1">
        <v-menu
          ref="endDateMenu"
          v-model="endDateMenu"
          :close-on-content-click="false"
          :return-value.sync="endDate"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endDate"
              label="End Date"
              readonly
              v-on="on"
              append-icon="mdi-calendar-range"
              color="purple darken-2"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="endDateMenu = false"
              >Cancel</v-btn
            >
            <v-btn text color="primary" @click="$refs.endDateMenu.save(endDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="d-flex" sm="1" v-if="show">
        <v-text-field
          label="ドメインID"
          single-line
          v-model="selectedDomain"
          color="purple darken-2"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex search-btn" sm="1">
        <v-btn rounded dark color="#7E6990" @click="search">
          検索
          <v-icon right>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-spacer></v-spacer>
  </div>
</template>

<script>
const accessLevelSuper = -9;
export default {
  data: () => ({
    show: false,
    startDateMenu: false,
    endDateMenu: false,
    selectedGeneration: "",
    selectedDocument: "",
    selectedEmployee: "",
    selectedDepartment: "",
    startDate: "",
    endDate: "",
    selectedDomain: "",
  }),
  computed: {
    generationList() {
      return this.$store.getters["domain/generationList"];
    },
    documentList() {
      return this.$store.getters["domain/documentList"];
    },
    employeeList() {
      return this.$store.getters["domain/employeeList"];
    },
    departmentList() {
      return this.$store.getters["domain/departmentList"];
    },
  },
  created: function () {
    this.getLists();
    this.search();
  },
  mounted: function () {
    this.showDomainSearchBox();
  },
  methods: {
    search() {
      const filter = this.createFilter();
      this.getGraphs(filter);
    },
    createFilter() {
      const tempFilter = {
        generation_id: this.selectedGeneration,
        document_id: this.selectedDocument,
        user_id: this.selectedEmployee,
        department_code: this.selectedDepartment,
        date_start: this.startDate,
        date_end: this.endDate,
        domain_id: this.selectedDomain,
      };
      let resultFilter = {};
      for (let [key, value] of Object.entries(tempFilter)) {
        if (!value) {
          continue;
        }
        if (key == "date_start" || key == "date_end") {
          resultFilter[key] = this.dateTypeConversion(value);
        } else {
          resultFilter[key] = value;
        }
      }
      return resultFilter;
    },
    dateTypeConversion(value) {
      let format = "yyyyMMdd";
      const date = new Date(value);
      format = format.replace(/yyyy/g, date.getFullYear());
      format = format.replace(/MM/g, ("0" + (date.getMonth() + 1)).slice(-2));
      format = format.replace(/dd/g, ("0" + date.getDate()).slice(-2));
      return format;
    },
    async getGraphs(filter) {
      const asyncDocumentFrequency = this.$store.dispatch(
        "domain/GET_DOCUMENT_FREQUENCY_LIST",
        filter
      );
      const asyncApprovalDocumentTimeAverage = this.$store.dispatch(
        "domain/GET_APPROVAL_DOC_TIME_AVERAGE_LIST",
        filter
      );
      const asyncApprovalTimeAverage = this.$store.dispatch(
        "domain/GET_APPROVAL_TIME_AVERAGE_LIST",
        filter
      );
      const asyncDocumentRejectionRate = this.$store.dispatch(
        "domain/GET_DOCUMENT_REJECTION_RATE_LIST",
        filter
      );
      const asyncRejectionRate = this.$store.dispatch(
        "domain/GET_USER_REJECTION_RATE_LIST",
        filter
      );
      const asyncDiviceFrequency = this.$store.dispatch(
        "domain/GET_DEVICE_FREQUENCY_LIST",
        filter
      );
      const applyDocumentNumber = this.$store.dispatch(
        "domain/GET_APPLY_DOCUMENT_NUMBER",
        filter
      );

      await Promise.all([
        asyncDocumentFrequency,
        asyncApprovalDocumentTimeAverage,
        asyncApprovalTimeAverage,
        asyncDocumentRejectionRate,
        asyncRejectionRate,
        asyncDiviceFrequency,
        applyDocumentNumber,
      ]);
      return;
    },
    async getLists() {
      const asyncGenerationList = this.$store.dispatch(
        "domain/GET_GENERATION_LIST"
      );
      const asyncEmployeeList = this.$store.dispatch(
        "domain/GET_EMPLOYEE_LIST"
      );
      const asyncDocumentList = this.$store.dispatch(
        "domain/GET_DOCUMENT_LIST"
      );
      const asyncDepartmentList = this.$store.dispatch(
        "domain/GET_DEPARTMENT_LIST"
      );

      await Promise.all([
        asyncGenerationList,
        asyncEmployeeList,
        asyncDocumentList,
        asyncDepartmentList
    ]);
      return;
    },
    showDomainSearchBox() {
      const accessLevel = this.$store.getters["logininfo/accesslevel"];
      if (accessLevel == accessLevelSuper) {
        this.show = true;
      }
    },
  },
};
</script>

<style scoped>
.search-btn {
  padding-top: 25px;
}
</style>
